export enum BookingScreenType {
  List = 'list',
  Links = 'links',
  Timeline = 'timeline',
}
